export default "__VITE_ASSET__OL$S7oiW__"